import * as React from "react"
import { batch, useSignal } from "@preact/signals-react";
import {Box} from "@mui/material";
import { SelectSeeker } from "@ui-seeker/core";

import {DateRangeBlock} from "@components";
import { GROUPED_BY, DATE_PERIODS } from "@constants";
import { splitKpi} from "@signals";
import { digitalShelfEvolutionFilters, digitalShelfEvolutionChartCurrentPeriod } from "../@signals";
import {rangeDatesDigitalShelf} from "./Ranges"

const KPI_OPTIONS = [
    { label: 'Digital Shelf KPI', value: 'average'},
    { label: 'Stock KPI', value: 'stock_kpi'},
    { label: 'Assortment KPI', value: 'assortment_kpi'},
    { label: 'Product Pages KPI', value: 'pp_kpi'},
    { label: 'Share of Search KPI', value: 'sos_kpi'},
    { label: 'Share of Search Organic KPI', value: 'sos_organic_kpi'},
    { label: 'Share of Search Sponsored KPI', value: 'sos_sponsored_kpi'}
]

export default function DigitalShelfEvolutionChartToolbar({kpi, dateRange, onChange}) {

    const kpiSelected = useSignal(kpi)

    const filteredKpiOptions = splitKpi.value.includes(GROUPED_BY.BRAND)
        ? KPI_OPTIONS.filter(option => !option.value.includes('sos'))
        : KPI_OPTIONS

    return <Box sx={{ display: 'flex', gap: 2, alignItems: 'center'}}>
        <DateRangeBlock
            currentPeriodLabel={digitalShelfEvolutionChartCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={rangeDatesDigitalShelf}
            onChange={onChange}
            onOk = { () => digitalShelfEvolutionChartCurrentPeriod.value = DATE_PERIODS.CUSTOM }
        />

        <SelectSeeker
            options={filteredKpiOptions}
            value={kpiSelected.value}
            onChange = { e => { batch(() => {
                kpiSelected.value = e.target.value
                digitalShelfEvolutionFilters.value = {
                    ...digitalShelfEvolutionFilters.value,
                    evolutionKPI: kpiSelected.value
                }
            })}}
        />
    </Box>
}
